import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { NguCarouselConfig } from '@ngu/carousel';
import { Router } from '@angular/router';
import { MyDatePicker, IMyDpOptions } from 'mydatepicker';
import { AppService } from '../services/app.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { environment } from '../../environments/environment';
import { SupportService } from '../services/support-service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { HomeSelectionSharedService } from '../services/home-selection-shared.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  @ViewChild('mydp') mydp: MyDatePicker;
  @ViewChild('mydp1') mydp1: MyDatePicker;
  @ViewChild('mydp2') mydp2: MyDatePicker;
  @ViewChild('insurance-focus') insuranceFocus: ElementRef;
  @ViewChild('placesRef') placesRef: GooglePlaceDirective;
  isMobile = false;
  examList: any = [];
  examList1: any = [];
  allExamList: any = [];
  defaultExamList: any = [];
  multiplePro = false;
  homeinfosubmit = false;
  popProcedures: any = [];
  paymode: any;
  selectedlang: any;
  selectIndex: any = -1;
  cptCodeList: any = [];
  scheduledData: any = {};
  nearAreas: any = [];
  placeholerCptCode: any = 'Procedure Name';
  couldFrontURL = environment.cloudFrontURL;
  recommendedTc: any = [];
  selectedExam: any;
  editProcedure = false;
  imgags = [
    './assets/images/img1.jpg',
    './assets/images/img1.jpg',
    './assets/images/img1.jpg',
    './assets/images/img1.jpg',
  ];
  public carouselTileItems: Array<any> = [];
  public carouselTiles = {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  };
  public carouselTile: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 4, lg: 4, all: 0 },
    slide: 4,
    speed: 250,
    point: {
      visible: false,
    },
    load: 2,
    velocity: 2,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
  };
  path: any;
  scheduleappointmentid: any = '';
  today: any = new Date();
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  public myDatePickerOptions: IMyDpOptions = {};
  homeDate: any = this.formatHomeDate(this.today);
  homeDatePlaceHolder: any = this.formatHomeDate(this.today);
  homeLocation: any = '';
  currentLocation: any = '';
  homeLocationPlaceholder: any = 'Location';
  homeInsurance: any = '';
  homeInsuranceName: any = '';
  homeInsuranceTypeName: any = '';
  homeInsuranceType: any = '';
  homeExamName: any = '';
  homeBodyPartName: any = '';
  countryId: any = 231;
  countryCode: any = 'US';
  popoverValidationMsg: any = 'Please select exam and body part';
  insuranceList: any;
  selectProcedureList: any = [];
  modalRef: BsModalRef;
  payMode: any = 'insurance';
  config = {
    ignoreBackdropClick: true,
  };
  disabledInsType = false;
  searchSelect = '';

  @ViewChild('anotherProcedure') anotherProcedure: TemplateRef<any>;
  @ViewChild('anotherProcedureNew') anotherProcedureNew: TemplateRef<any>;
  @ViewChild('insuranceModal') insuranceModal: TemplateRef<any>;
  @ViewChild('examModal') examModal: TemplateRef<any>;
  @ViewChild('bodyPartModal') bodyPartModal: TemplateRef<any>;
  @ViewChild('ProcedureModal') ProcedureModal: TemplateRef<any>;
  @ViewChild('insuranceTypeModal') insuranceTypeModal: TemplateRef<any>;

  constructor(
    private appservice: AppService,
    private datePipe: DatePipe,
    private router: Router,
    private modalService: BsModalService,
    private supportService: SupportService,
    private cdRef: ChangeDetectorRef,
    private toastr: ToastrService,
    private homeSelectionShared: HomeSelectionSharedService
  ) {
    this.today.setHours(0, 0, 0, 0);
    this.currentDate = this.today.getDate() - 1;
    this.currentMonth = this.today.getMonth() + 1;
    this.currentYear = this.today.getFullYear();
    this.myDatePickerOptions = {
      dateFormat: 'mmm dd, yyyy',
      minYear: +this.currentYear,
      firstDayOfWeek: 'su',
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      //maxYear: +this.currentYear,
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: false,
      inline: false,
    };
  }

  clearSearch() {
    return this.homeSelectionShared.clearSearch(this);
  }

  private getAddressComponent(components: any[], ...types: string[]): any {
    if (!components || !components.length) {
      return null;
    }
    for (const type of types) {
      const match = components.find((component) => {
        return component.types && component.types.indexOf(type) >= 0;
      });
      if (match) {
        return match;
      }
    }
    return null;
  }

  private applyCountryFromComponents(components: any[]): void {
    const country = this.getAddressComponent(components, 'country');
    if (!country) {
      return;
    }
    if (country.long_name === 'India' && country.short_name === 'IN') {
      this.countryCode = 'IN';
      this.countryId = 101;
      this.placeholerCptCode = 'Procedure Name';
      this.homeInsuranceType = 2;
    } else {
      this.countryCode = 'US';
      this.countryId = 231;
      this.placeholerCptCode = 'Procedure Name';
      this.homeInsuranceType = '';
    }
    this.homeInsurance = '';
    this.homeInsuranceName = '';
    this.homeInsuranceTypeName = '';
    this.supportService.countryCode.next(this.countryCode);
    this.insuranceList = [];
    this.getallinsurancebycountry();
  }

  private simplifyFormattedAddress(formatted: string): string {
    return formatted
      .replace(/,?\s{0,20}India\s{0,20}$/i, '')
      .replace(/,?\s{0,20}United States( of America)?\s{0,20}$/i, '')
      .replace(/,?\s{0,20}\d{5,6}\s{0,20}$/, '')
      .trim();
  }

  private buildHomeLocationFromComponents(
    components: any[],
    countryCode: string
  ): string {
    if (!components || !components.length) {
      return '';
    }
    const parts: string[] = [];
    const pushUnique = (value: string) => {
      const trimmed = (value || '').trim();
      if (!trimmed) {
        return;
      }
      if (parts.some((part) => part.toLowerCase() === trimmed.toLowerCase())) {
        return;
      }
      parts.push(trimmed);
    };

    if (countryCode === 'IN') {
      const area = this.getAddressComponent(
        components,
        'sublocality_level_1',
        'sublocality',
        'sublocality_level_2',
        'neighborhood',
        'locality',
        'administrative_area_level_3'
      );
      const district = this.getAddressComponent(
        components,
        'administrative_area_level_2'
      );
      const state = this.getAddressComponent(
        components,
        'administrative_area_level_1'
      );
      if (area) {
        pushUnique(area.long_name);
      }
      if (district) {
        pushUnique(district.long_name);
      }
      if (state) {
        pushUnique(state.short_name);
      }
    } else {
      const city = this.getAddressComponent(
        components,
        'locality',
        'sublocality',
        'neighborhood'
      );
      const state = this.getAddressComponent(
        components,
        'administrative_area_level_1'
      );
      if (city) {
        pushUnique(city.long_name);
      }
      if (state) {
        pushUnique(state.short_name);
      }
    }
    return parts.join(', ');
  }

  private buildHomeLocationFromPlace(address: any): string {
    const components = (address && address.address_components) || [];
    const country = this.getAddressComponent(components, 'country');
    const countryCode =
      country && country.short_name === 'IN' ? 'IN' : this.countryCode || 'US';
    const fromComponents = this.buildHomeLocationFromComponents(
      components,
      countryCode
    );
    if (fromComponents && !/^[A-Za-z]{2}$/.test(fromComponents.trim())) {
      return fromComponents;
    }
    if (address && address.formatted_address) {
      return this.simplifyFormattedAddress(address.formatted_address);
    }
    if (address && address.adr_address) {
      return address.adr_address.split('<').map(s => s.includes('>') ? s.slice(s.indexOf('>') + 1) : s).join('').trim();
    }
    return fromComponents;
  }

  private readPlaceCoordinates(address: any): { lat: number; lng: number } | null {
    if (!address || !address.geometry || !address.geometry.location) {
      return null;
    }
    const location = address.geometry.location;
    const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
    const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
    if (lat == null || lng == null || isNaN(+lat) || isNaN(+lng)) {
      return null;
    }
    return { lat: +lat, lng: +lng };
  }

  selectAddress() {
    const ele = document.querySelectorAll('.pac-container');
    if (ele.length > 0) {
      ele.forEach((element, index) => {
        ele[index].setAttribute(
          'class',
          'pac-container pac-logo hdpi home-top'
        );
      });
    }
  }

  gotoTestcenter(tcobj) {
    if (tcobj) {
      const data = {
        scheduleOn: this.datePipe.transform(this.homeDate, 'yyyy-mm-dd'),
        cptCodes: null,
        tcId: tcobj.testcenterId,
        profile: tcobj.profileImage,
        tcView: tcobj,
      };
      localStorage.setItem('tcdetail', JSON.stringify(data));
      if (this.scheduleappointmentid) {
        this.router.navigate(['/detail-page', this.scheduleappointmentid]);
      } else {
        this.router.navigate(['/detail-page']);
      }
    }
  }

  ngOnDestroy() {
    this.unsub.unsubscribe();
  }

  unsub: any;
  ngOnInit() {
    sessionStorage.clear();
    const email = localStorage.getItem('email');
    const password = localStorage.getItem('password');
    localStorage.clear();
    if (email) {
      localStorage.setItem('email',email);
    }
    if (password) {
      localStorage.setItem('password',password);
    }
    this.supportService.patientname.next('');
    if (window.screen.width <= 540) {
      this.isMobile = true;
    }
    this.getExams(1, 'view');
    this.getallexams();
    this.path = this.router.url;
    const Splitpath = this.path.split('/');
    if (Splitpath && Splitpath.length == 3) {
      this.scheduleappointmentid = Splitpath[2];
      this.viewscheduleapp();
      if (this.isMobile) {
        this.scrollTop('schedulediv');
        setTimeout(() => {
          document.body.scrollTop -= 50; // For Safari
          document.documentElement.scrollTop -= 50; // For Chrome, Firefox, IE and Opera
        }, 100);
      }
    } else {
      this.addSelectProcedureList();
      this.getCurrentLocation();
    }
    this.getLanguage();
    this.supportService.showback.next(false);
    this.supportService.headerSignBtnHandle.next(true);
    this.unsub = this.supportService.getCityName.subscribe((res) => {
      if (res) {
        this.homeLocation = res;

        setTimeout(() => {
          document.getElementById("location-search").focus();

        this.scrollTop('recommendedforyou');
        }, 200);
        

        this.currentLocation = res;
        this.getAddressBasedonAddress(res);
      }
    });
  }

  getAddressBasedonAddress(searchaddress) {
    this.appservice.getAddressBasedonAddress(searchaddress).subscribe(
      (res) => {
        if (res['results'][0]) {
          const lat = res['results'][0].geometry.location.lat;
          const lng = res['results'][0].geometry.location.lng;
          this.lat = lat;
          this.lng = lng;
          this.getallrecomendedtc();
          this.getallareasbylatlng();
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  viewscheduleapp() {
    this.appservice
      .viewscheduleappointmentpro(this.scheduleappointmentid)
      .subscribe(
        (res) => {
          if (res && res['status'] && res['status']['status'] == 200) {
            if (res['entity'] && res['entity'].schedule) {
              if (
                res['entity']['schedule']['noshow'] ||
                res['entity']['schedule']['canceled'] ||
                res['entity']['schedule']['patientCheckIn']
              ) {
                this.toastr.error(
                  'not eligible for reschedule, Please maken new schedule'
                );
                this.router.navigate(['/home']);
                return;
              }
              if (res['entity'].schedule.payMode == 'self') {
                this.homeInsurance = 'self';
                this.homeInsuranceType = '';
                this.homeInsuranceName = 'Self Pay';
                this.disabledInsType = true;
              } else {
                if (
                  res['entity'].schedule.payMode == 'insurance' &&
                  res['entity'].schedInsurance &&
                  res['entity'].schedInsurance.length > 0
                ) {
                  this.homeInsurance =
                    res['entity'].schedInsurance[0].insuranceId;
                  this.homeInsuranceType =
                    res['entity'].schedInsurance[0].insuranceTypeId;
                  this.homeInsuranceName =
                    res['entity'].schedInsurance[0].insuranceName;
                  if (res['entity'].schedInsurance[0].insuranceTypeId == 2) {
                    this.homeInsuranceTypeName = 'HMO';
                  } else if (
                    res['entity'].schedInsurance[0].insuranceTypeId == 3
                  ) {
                    this.homeInsuranceTypeName = 'PPO';
                  } else {
                    this.disabledInsType = true;
                  }
                }
              }
              if (res['entity'].schedule.countryName == 'India') {
                this.countryCode = 'IN';
                this.placeholerCptCode = 'Procedure Name';
                this.countryId = 101;
                this.homeInsuranceType = 2;
              } else {
                this.countryCode = 'US';
                this.placeholerCptCode = 'Procedure Name';
                this.countryId = 231;
              }
            
              this.getallinsurancebycountry();
              this.homeExamName = res['entity'].selectProcedures[0].examName;
              this.homeBodyPartName =
                res['entity'].selectProcedures[0].bodyPartName;
              this.homeDate = this.datePipe.transform(
                res['entity'].schedule.scheduledOn,
                'MMM dd, yyyy'
              );
              this.homeLocation = res['entity'].schedule.choosenLocation;
              this.lat = res['entity'].schedule.latitude;
              this.lng = res['entity'].schedule.longitude;
              this.selectProcedureList = res['entity'].selectProcedures;
              this.supportService.countryCode.next(this.countryCode);
              this.getOffsetZone(this.lat,this.lng,this.countryId);
              this.getallrecomendedtc();
              this.getallareasbylatlng();
              if (
                this.selectProcedureList &&
                this.selectProcedureList.length > 1
              ) {
                this.multiplePro = true;
              }
              if (
                this.selectProcedureList &&
                this.selectProcedureList.length > 0
              ) {
                for (let s = 0; s < this.selectProcedureList.length; s++) {
                  if (
                    this.selectProcedureList[s].procedureList &&
                    this.selectProcedureList[s].procedureList.length > 0
                  ) {
                    for (
                      let p = 0;
                      p < this.selectProcedureList[s].procedureList.length;
                      p++
                    ) {
                      if (
                        this.selectProcedureList[s].procedureList[p].cptCode ==
                        this.selectProcedureList[s].cptCode
                      ) {
                        this.selectProcedureList[s].procedureList[
                          p
                        ].checked = true;
                      } else {
                        this.selectProcedureList[s].procedureList[
                          p
                        ].checked = false;
                      }
                    }
                  }
                }
              } else {
                this.addSelectProcedureList();
              }
            }
          } else {
            this.router.navigate(['/home']);
          }
        },
        (err) => {}
      );
  }

  timeZoneconverttoMinutes(value) {
    let timezone = 0;
    if (value) {
      timezone = value / 60;
    }
    return +timezone;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  openModal(template: TemplateRef<any>) {
    this.searchSelect = '';
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: 'popup-center addpro-popup' })
    );
  }

  formatHomeDate(date) {
    return this.homeSelectionShared.formatHomeDate(date);
  }
  onToggleCalendar(event: any): void {
    return this.homeSelectionShared.onToggleCalendar(this, event);
  }

  onToggleCalendar1(event: any): void {
    return this.homeSelectionShared.onToggleCalendar1(this, event);
  }

  onToggleCalendar2(event: MyDatePicker, ev: any): void {
    ev.stopPropagation();
    event.openBtnClicked();
  }

  getLanguage() {
    return this.homeSelectionShared.getLanguage(this);
  }

  onDateChanged(event) {
    this.showErrDate = false;
    if (event && event.formatted) {
      this.homeDate = event.formatted;
    }
  }

  onCalendarToggle(event: number) {
    console.log('onCalendarToggle(): Reason: ', event);
  }

  lat: number;
  lng: number;
  private skipAutoDetectedLocation = false;

  getCurrentLocation() {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (showPosition) => {
          this.lat = showPosition.coords.latitude;
          this.lng = showPosition.coords.longitude;
          this.getAddressBasedonLatandLng(this.lat, this.lng);
        },
        (showError) => {
          this.showError(showError);
          this.getCurrentIPAddress();
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      this.getCurrentIPAddress();
    }
  }

  showError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        break;
      case error.POSITION_UNAVAILABLE:
        break;
      case error.TIMEOUT:
        break;
      case error.UNKNOWN_ERROR:
        break;
    }
  }

  getCurrentIPAddress() {
    this.appservice.getCurrentIPAddress().subscribe(
      (res) => {
        if (res && res['ip']) {
          this.getAddressBasedonCurrentIp(res['ip']);
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getAddressBasedonCurrentIp(ip) {
    this.appservice.getAddressBasedonCurrentIp(ip).subscribe(
      (res) => {
        if (this.skipAutoDetectedLocation) {
          return;
        }
        if (res && res['status'] === 'success' && res['countryCode']) {
          this.countryCode = res['countryCode'];
          this.supportService.countryCode.next(this.countryCode);
          this.homeLocation = '';
          if (res['city']) {
            this.homeLocation = this.homeLocation + res['city'] + ', ';
          }
          if (res['region']) {
            this.homeLocation = this.homeLocation + res['region'] + ', ';
          }
          if (res['countryCode']) {
            this.homeLocation = this.homeLocation + res['countryCode'];
          }
          this.currentLocation = this.homeLocation;
          this.homeLocationPlaceholder = 'Location';
          this.lat = res['lat'];
          this.lng = res['lon'];
          if (res['countryCode'] == 'IN') {
            this.placeholerCptCode = 'Procedure Name';
            this.countryId = 101;
            this.homeInsuranceType = 2;
          } else {
            this.placeholerCptCode = 'Procedure Name';
            this.countryId = 231;
          }

          if(localStorage.getItem("countryCode")){
            localStorage.setItem("countryCode",this.countryCode);
          }

          this.getOffsetZone(+res['lat'], +res['lon'],this.countryId);

          this.getallinsurancebycountry();
          this.getallrecomendedtc();
          this.getallareasbylatlng();
        } else if (
          res &&
          res['status'] == 'success' &&
          res['lat'] &&
          res['lon']
        ) {
          if (!this.skipAutoDetectedLocation) {
            this.getAddressBasedonLatandLng(+res['lat'], +res['lon']);
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getAddressBasedonLatandLng(latitude, longitude) {
    if (latitude && longitude) {
      this.homeLocationPlaceholder = 'Location';
      this.appservice.getAddressFromGoogle(latitude, longitude).subscribe(
        (res) => {
          if (this.skipAutoDetectedLocation) {
            return;
          }
          if (
            res &&
            res['status'] &&
            (res['status'] == 'ok' || res['status'] == 'OK')
          ) {
            if (res['results'][0]) {
              const result = res['results'][0];
              if (result['address_components']) {
                this.applyCountryFromComponents(result['address_components']);
                if (!localStorage.getItem("countryCode")) {
                  localStorage.setItem("countryCode", this.countryCode);
                }
                this.getOffsetZone(latitude, longitude, this.countryId);
                this.homeLocation = this.buildHomeLocationFromPlace(result);
                this.currentLocation = this.homeLocation;
                this.homeLocationPlaceholder = 'Location';
                this.getallrecomendedtc();
                this.getallareasbylatlng();
              }
            }
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  getOffsetZone(latitude, longitude,type) {
    return this.homeSelectionShared.getOffsetZone(this, latitude, longitude, type);
  }
  
  getallrecomendedtc() {
    const day = new Date(this.homeDate).getDay();

    this.findDay(day);

    const data = {
      scheduleOn: this.datePipe.transform(this.homeDate, 'yyyy-MM-dd'),
      dayOfweek: this.dayOfweek,
      latitude: this.lat,
      longitude: this.lng,
    };

    this.appservice.gettestcentersbylocation(data).subscribe(
      (res) => {
        if (
          res &&
          res['status'] &&
          res['status']['status'] &&
          res['status']['status'] == 200
        ) {
          this.recommendedTc = res['entity'];
          if (this.recommendedTc) {
            this.carouselTileItems = this.recommendedTc;
          }
        } else {
          this.carouselTileItems = [];
        }
      },
      (err) => ({})
    );
  }

  getallareasbylatlng() {
    const data = {
      latitude: this.lat,
      longitude: this.lng,
    };
    this.appservice.getallareasbylatlng(data).subscribe(
      (res) => {
        if (
          res &&
          res['status'] &&
          res['status']['status'] &&
          res['status']['status'] == 200
        ) {
          this.nearAreas = [];
          if (res['entity'] && res['entity'].areas) {
            this.nearAreas = res['entity'].areas;
          }
        } else {
          this.nearAreas = [];
        }
      },
      (err) => {
        this.nearAreas = [];
      }
    );
  }

  getallinsurancebycountry() {
    const data = {
      countryId: this.countryId,
    };

    this.appservice.getallinsurancebycountry(data).subscribe(
      (res) => {
        if (
          res &&
          res['status'] &&
          res['status']['status'] &&
          res['status']['status'] == 200
        ) {
          this.insuranceList = res['entity'];
        }
      },

      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }
  removeSelectProcedureList(index) {
    this.homeinfosubmit = false;
    this.selectProcedureList.splice(index, 1);
    if (this.selectProcedureList && this.selectProcedureList.length == 1) {
      this.multiplePro = false;
    }
  }

  showErrDate = false;
  validate(schedDate) {
    return this.homeSelectionShared.validate(this, schedDate);
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView({ behavior: 'smooth' });
  }

  setExamonTop(exam, type) {
    this.selectProcedureList[0].examId = exam.id;
    this.homeExamName = exam.examshortname;
    this.selectProcedureList[0].bodyPartId = '';
    this.homeBodyPartName = '';
    this.getallbodypartsbyexamid(exam.id, 0);
    if (type == 'mobile') {
      this.scrollTop('schedulediv');
      setTimeout(() => {
        document.body.scrollTop -= 50; // For Safari
        document.documentElement.scrollTop -= 50; // For Chrome, Firefox, IE and Opera
      }, 800);
    } else if (type == 'web') {
      this.scrollTop('scheduleform');
    }
  }

  getallexams() {
    this.appservice.getAllExams().subscribe(
      (res) => {
        if (res && res['entity']) {
          this.allExamList = res['entity'];
          for (let index = 0; index < this.allExamList.length; index++) {
            if(this.allExamList[index].id === 5){
              this.allExamList[index].examshortname = "UltraSound";
            }else if(this.allExamList[index].id === 3){
              this.allExamList[index].examshortname = "CT SCAN";
            }else if(this.allExamList[index].id === 7){
              this.allExamList[index].examshortname = "X-RAY";
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }
  other = false;
  mobile: any;
  type: any;
  getExams(mob, type) {
    this.mobile = 2;
    if (this.mobile == mob) {
      this.other = false;
    }
    this.appservice.getAllExams().subscribe(
      (res) => {
        if (res && res['status'] && res['status']['status'] == 200) {
          this.examList1 = res['entity'];
          if (!this.isMobile) {
            this.type = 'view';
            if (type == 'default') {
              this.examList = [];
              for (let index = 0; index < 8; index++) {
                this.examList.push(res['entity'][index]);
              }
            } else {
              this.examList = res['entity'];
              this.type = 'default';
            }
          } else {
            if (type == 'default') {
              this.examList = [];
              for (let index = 0; index < 7; index++) {
                this.examList.push(res['entity'][index]);
              }
            } else {
              this.examList = res['entity'];
            }
          }
        } else {
          this.examList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  timezone_offset_min: any;
  offset_hrs: any;
  offset_min: any;

  convetTimeZoneOffsetToTime() {
    this.timezone_offset_min = new Date().getTimezoneOffset();
    this.offset_hrs = Math.abs(this.timezone_offset_min / 60);
    this.offset_min = Math.abs(this.timezone_offset_min % 60);
    let timezone_standard = '';

    if (this.offset_hrs < 10) {
      this.offset_hrs = '0' + Math.floor(this.offset_hrs);
    }

    if (this.offset_min < 10) {
      this.offset_min = '0' + this.offset_min;
    }

    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if (this.timezone_offset_min < 0) {
      timezone_standard =
        '+' + this.offset_hrs.toString() + ':' + this.offset_min.toString();
    } else if (this.timezone_offset_min > 0) {
      timezone_standard =
        '-' + this.offset_hrs.toString() + ':' + this.offset_min.toString();
    } else if (this.timezone_offset_min == 0) {
      timezone_standard = '+00:00';
    }
    return timezone_standard.toString();
  }

  redirectToScheduleForm(exam) {
    const date1 = moment(
      this.datePipe.transform(this.homeDate, 'yyyy-MM-dd') + ' 00:00:00'
    );
    const date2 = moment(
      this.datePipe.transform(this.today, 'yyyy-MM-dd') + ' 00:00:00'
    );
    const date3 = new Date();
    date3.setMinutes(0);
    date3.setSeconds(0);
    const scheduleOn = this.datePipe.transform(this.homeDate, 'yyyy-MM-dd');
    const day = new Date(this.homeDate).getDay();
    this.findDay(day);
    this.findpaymode();
    this.cptCodeList = [];
    if (
      this.homeDate &&
      this.homeLocation &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        }
      }
      this.scheduledData = {
        scheduleId: this.scheduleappointmentid,
        scheduleOn: scheduleOn,
        scheduleOnStr: scheduleOn,
        dayOfweek: this.dayOfweek,
        location: this.homeLocation,
        insuranceId:
          this.homeInsurance &&
          this.homeInsurance != '' &&
          this.homeInsurance != 'self'
            ? this.homeInsurance
            : 0,
        inType:
          this.homeInsuranceType && this.homeInsuranceType != ''
            ? this.homeInsuranceType
            : 0,
        selectProcedureList: this.selectProcedureList,
        cptCodeList: this.cptCodeList,
        payMode: this.paymode,
        countryCode: this.countryCode,
        latitude: this.lat,
        longitude: this.lng,
        selectedExam: exam && exam.examshortname ? exam.examshortname : '',
        selectedExamId: exam && exam.id ? exam.id : '',
        today: date1.toString() === date2.toString() ? true : false,
        timeZone: this.convetTimeZoneOffsetToTime(),
        currentTime: this.datePipe.transform(date3, 'hh:mm aa'),
      };
      sessionStorage.setItem(
        'scheduleData',
        JSON.stringify(this.scheduledData)
      );
      if (this.scheduleappointmentid && this.scheduleappointmentid != '') {
        this.router.navigate(['/schedule-form', this.scheduleappointmentid]);
      } else {
        this.router.navigate(['/schedule-form']);
      }
    }
  }

  redirectToLocation() {
    return this.homeSelectionShared.redirectToLocation(this);
  }

  getallbodypartsbyexamid(examid, index) {
    const data = {
      examId: examid,
    };
    this.selectProcedureList[index].examId = examid;
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          this.selectProcedureList[index].bodyPartList = res['entity'];
          if (this.allExamList && this.allExamList.length > 0) {
            for (let i = 0; i < this.allExamList.length; i++) {
              if (
                this.allExamList[i].id == this.selectProcedureList[index].examId
              ) {
                this.selectProcedureList[index].examName = this.allExamList[
                  i
                ].examshortname;
                break;
              }
            }
          }
          this.selectProcedureList[index].bodyPartId = '';
          this.selectProcedureList[index].bodyPartName = '';
          this.selectProcedureList[index].cptCode = '';
          this.selectProcedureList[index].procedureName = '';
          this.selectProcedureList[index].procedureList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallproceduresbybodypart(bodypartId, index) {
    this.loadProceduresByBodyPart(bodypartId, index, true);
  }

  loadProceduresByBodyPart(bodypartId, index, openProcedurePopover, onLoaded?) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          for (let e = 0; e < res['entity'].length; e++) {
            res['entity'][e].checked = false;
          }
          this.selectProcedureList[index].cptCode = '';
          this.selectProcedureList[index].procedureName = '';
          this.selectProcedureList[index].selectedProcedure = '';
          this.selectProcedureList[index].procedureList = res['entity'];
          if (!openProcedurePopover && index === 0) {
            this.selectProcedureList[index].open = false;
            this.popProcedures = this.selectProcedureList[index].procedureList;
          }
          if (
            this.selectProcedureList[index].bodyPartList &&
            this.selectProcedureList[index].bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].bodyPartList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].bodyPartList[i].id == bodypartId
              ) {
                this.selectProcedureList[
                  index
                ].bodyPartName = this.selectProcedureList[index].bodyPartList[
                  i
                ].bodyPart;
                if (openProcedurePopover) {
                  this.selectProcedureList[index].open = true;
                  this.openpopuptemplate(
                    this.selectProcedureList[index].procedureList,
                    index
                  );
                }
                break;
              }
            }
          }
          if (onLoaded) {
            onLoaded();
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  addSelectProcedureList() {
    return this.homeSelectionShared.addSelectProcedureList(this);
  }

  setMyStyles(id) {
    let styles;
    if(id === 2 || id === 4){
       styles = {
        'background-image': 'url(./assets/images/exams-' + id + '.png)',
      };
    } else {
       styles = {
        'background-image': 'url(./assets/images/exams-' + id + '.jpg)',
      };
    }
    return styles;
  }
  
  openpopuptemplate(procedures, ind) {
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (s != ind) {
          this.selectProcedureList[s].open = false;
        }
      }
    }
    this.selectIndex = ind;
    if (procedures && procedures.length > 0) {
      this.selectProcedureList[ind].open = true;
      this.popProcedures = procedures;
    } else {
      this.popProcedures = [{ id: '', cptCode: '', procedureName: '' }];
      this.selectProcedureList[ind].open = false;
    }
  }

  selectMultipleProcedure() {
    return this.homeSelectionShared.selectMultipleProcedure(this);
  }

  changeCptCode(value, spInd, ind, procedure) {
    let isExist = false;
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (this.selectProcedureList[s].cptCode == procedure.cptCode) {
          isExist = true;
          break;
        }
      }
    }
    if (!isExist) {
      this.selectProcedureList[spInd].procedureList[ind].checked = value;
      this.selectProcedureList[spInd].cptCode = procedure.cptCode;
      this.selectProcedureList[spInd].procedureName = procedure.procedureName;
      this.selectProcedureList[spInd].open = false;
    } else {
      this.toastr.error('Procedure already selected');
    }
  }

  private isInsuredProcedureSelectionValid(): boolean {
    if (
      this.homeDate &&
      !this.showErrDate &&
      this.homeLocation &&
      this.homeInsurance &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          //this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  }

  confirmModal(type) {
    let valid = true;
    this.homeinfosubmit = true;
    if (this.countryCode == 'IN') {
      if (!this.homeInsurance) {
        this.toastr.error('Please fill all the fields');
        return;
      }
      valid = this.isInsuredProcedureSelectionValid();
    }
    if (this.countryCode == 'US') {
      if (!this.homeInsurance) {
        this.toastr.error('Please fill Insurance');
        return;
      }
      if (!this.homeInsuranceType && this.homeInsurance != 'self') {
        this.toastr.error('Please fill Insurance type');
        return;
      }
      valid = this.isInsuredProcedureSelectionValid();
    }

    if (valid) {
      if (type == 'web') {
        document.getElementById('yesnopopupmodal').click();
      } else if (type == 'mobile') {
        document.getElementById('yesnopopup1modal').click();
      }
    } else {
      this.toastr.error('Please fill all the fields.');
    }
  }

  navigatePatientProfileform(type) {
    let valid = true;
    this.homeinfosubmit = true;
    if (this.countryCode == 'IN') {
      if (!this.homeInsurance) {
        this.toastr.error('Please fill Insurance');
        return;
      }
      valid = this.isInsuredProcedureSelectionValid();
    }
    if (this.countryCode == 'US') {
      if (!this.homeInsurance) {
        this.toastr.error('Please fill Insurance');
        return;
      }
      if (!this.homeInsuranceType && this.homeInsurance != 'self') {
        this.toastr.error('Please fill Insurance type');
        return;
      }
      valid = this.isInsuredProcedureSelectionValid();
    }
    if (valid) {
      if (type != 'mobile' && type != 'no') {
        this.modalRef.hide();
      } else if (type == 'no') {
        document.getElementById('close-modal').click();
        document.getElementById('close-modal1').click();
      } else if (type == 'mobile') {
        document.getElementById('close-modal1').click();
      }

      if (this.homeInsuranceType == '') {
        this.homeInsuranceType = '2';
      }

      this.pushScheduledData(type);
    } else {
      this.toastr.error('Please fill all the fields.');
    }
  }

  openInsuranceModal() {
    this.openModal(this.insuranceModal);
  }

  openPopup(type) {
    if (this.isMobile) {
      if (type == '') {
        this.modalRef.hide();
      }
      setTimeout(() => {
        if (!this.homeInsuranceName) {
          this.openInsuranceModal();
        } else if (
          this.countryCode != 'IN' &&
          this.homeInsurance != 'self' &&
          !this.homeInsuranceType
        ) {
          this.openInsuranceTypeModal();
        } else if (!this.homeExamName) {
          this.openExamModal();
        } else if (!this.homeBodyPartName) {
          this.openBodyPartModal();
        } else if (!this.selectProcedureList[0].procedureName) {
          this.openProcedureModal();
        }
      }, 100);
    }
  }

  selectInsuranceValue(insurance) {
    if (insurance == 'self') {
      this.homeInsurance = 'self';
      this.homeInsuranceName = 'Self Pay';
    } else {
      this.homeInsurance = insurance.id;
      this.homeInsuranceName = insurance.name;
    }
    this.changeHomeInsurance(insurance);
  }

  openInsuranceTypeModal() {
    this.openModal(this.insuranceTypeModal);
  }

  selectInsuranceTypeValue(type, name) {
    this.homeInsuranceType = type;
    this.homeInsuranceTypeName = name;
    this.openPopup('');
  }

  openExamModal() {
    this.openModal(this.examModal);
  }

  selectExamValue(exam) {
    this.selectProcedureList[0].examId = exam.id;
    this.homeExamName = exam.examshortname;
    this.selectProcedureList[0].bodyPartId = '';
    this.homeBodyPartName = '';
    this.getallbodypartsbyexamid(exam.id, 0);
    this.openPopup('');
  }

  openBodyPartModal() {
    this.openModal(this.bodyPartModal);
  }

  selectBodyPartValue(bodyPart) {
    this.selectProcedureList[0].bodyPartId = bodyPart.id;
    this.homeBodyPartName = bodyPart.bodyPart;
    this.selectProcedureList[0].cptCode = '';
    this.selectProcedureList[0].procedureName = '';
    this.selectProcedureList[0].selectedProcedure = '';
    this.selectProcedureList[0].procedureList = [];
    this.popProcedures = [];
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.loadProceduresByBodyPart(bodyPart.id, 0, false, () => {
      this.openProcedureModal();
    });
  }

  openProcedureModal() {
    this.openModal(this.ProcedureModal);
  }

  scheduleFormSubmit(type) {
    let valid = true;
    this.homeinfosubmit = true;
    if (
      this.homeDate &&
      !this.showErrDate &&
      this.homeLocation &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          //this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        } else {
          valid = false;
          break;
        }
      }
    } else {
      valid = false;
    }
    if (valid) {
      if (type != 'modal') {
        document.getElementById('close-modal').click();
        this.openModal(this.anotherProcedureNew);
      } else if (type == 'modal') {
        this.selectMultipleProcedure();
      }
    } else {
      this.toastr.error('Please fill all the fields.');
    }
  }

  cancelModal() {
    const valid = true;
    for (let s = 0; s < this.selectProcedureList.length; s++) {
      if (this.selectProcedureList[s].procedureName == '') {
        this.selectProcedureList.splice(s, 1);
        break;
      }
    }
    for (let index = 0; index < this.selectProcedureList.length; index++) {
      this.selectProcedureList[index].open = false;
    }
    this.modalRef.hide();
  }

  dayOfweek = '';
  findDay(day) {
    if (day == 0) {
      this.dayOfweek = 'Sunday';
    }
    if (day == 1) {
      this.dayOfweek = 'Monday';
    }
    if (day == 2) {
      this.dayOfweek = 'Tuesday';
    }
    if (day == 3) {
      this.dayOfweek = 'Wednesday';
    }
    if (day == 4) {
      this.dayOfweek = 'Thursday';
    }
    if (day == 5) {
      this.dayOfweek = 'Friday';
    }
    if (day == 6) {
      this.dayOfweek = 'saturday';
    }
  }
  changeHomeInsurance(ins) {
    if (ins == 'self' || ins == '') {
      this.disabledInsType = true;
      this.homeInsuranceType = '';
      this.payMode = 'self';
      this.homeInsuranceTypeName = '';
    } else {
      this.disabledInsType = false;
      this.payMode = 'insurance';
      if (this.countryCode == 'IN') {
        this.homeInsuranceType = 2;
      }
    }
    this.openPopup('');
  }

  blurHomeLocation() {
    const typed = String(this.homeLocation || '').trim();
    if (!typed || typed === this.currentLocation) {
      return;
    }
    this.skipAutoDetectedLocation = true;
    this.getAddressBasedonAddress(typed);
  }

  timeZone = 0;
  onChangeAddress(address) {
    const coordinates = this.readPlaceCoordinates(address);
    if (!coordinates) {
      return;
    }
    this.skipAutoDetectedLocation = true;
    this.lat = coordinates.lat;
    this.lng = coordinates.lng;
    if (address && address['address_components']) {
      this.applyCountryFromComponents(address['address_components']);
      this.homeLocation = this.buildHomeLocationFromPlace(address);
      this.currentLocation = this.homeLocation;
      if(this.countryCode == 'IN'){
        this.getOffsetZone(this.lat,this.lng,101);
      }else {
        this.getOffsetZone(this.lat,this.lng,231);
      }
      this.homeLocationPlaceholder = 'Location';
      this.getallrecomendedtc();
      this.getallareasbylatlng();
      this.openPopup('start');
    }
  }

  findpaymode() {
    return this.homeSelectionShared.findpaymode(this);
  }

  changeHomeCptCode(procedure) {
    return this.homeSelectionShared.changeHomeCptCode(this, procedure);
  }

  cptcodeobject: any;
  getallExamListOnchange(cptcode, index) {
    const data = { cptcode: cptcode };

    this.appservice
      .getallexamdandprocedureandbodypartbycptcodeForhome(data)
      .subscribe((res) => {
        if (res && res['status']['status'] === 200) {
          if (
            res &&
            res['entity'] &&
            res['entity']['bodyPart'] &&
            res['entity']['bodyPart']['exam']
          ) {
            this.cptcodeobject = res['entity'];
            this.selectProcedureList[index].examId =
              res['entity']['bodyPart']['exam']['id'];
            this.selectProcedureList[index].examName =
              res['entity']['bodyPart']['exam']['examshortname'];
            this.homeExamName =
              res['entity']['bodyPart']['exam']['examshortname'];
            this.selectProcedureList[index].invalidcptcode = false;
            this.selectProcedureList[index].cptCode = this.cptcodeobject[
              'cptCode'
            ];
            this.selectProcedureList[index].tmpcptcode = this.cptcodeobject[
              'cptCode'
            ];
            this.getallbodypartsbyexamonchange(
              this.selectProcedureList[index].examId,
              index
            );
          }
        } else if (res['status']['status'] === 204) {
          this.toastr.error('Please check your cptcode');
          this.selectProcedureList[index].invalidcptcode = true;
          this.selectProcedureList[index].bodyPartId = '';
          this.selectProcedureList[index].bodyPartName = '';
          this.selectProcedureList[index].procedureName = '';
          this.selectProcedureList[index].procedureList = [];
          this.selectProcedureList[index].examId = '';
        }
      });
  }

  getallbodypartsbyexamonchange(examid, index) {
    const data = { examId: examid };
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res['status'] && res['status']['status'] == 204) {
          this.toastr.error('Procedure is not available');
          this.selectProcedureList[index].examId = '';
        } else if (res && res['entity']) {
          this.selectProcedureList[index].bodyPartList = res['entity'];
          if (
            this.cptcodeobject &&
            this.selectProcedureList[index].bodyPartList &&
            this.selectProcedureList[index].bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].bodyPartList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].bodyPartList[i].id ==
                this.cptcodeobject['bodyPart']['id']
              ) {
                this.selectProcedureList[index].bodyPartId = this.cptcodeobject[
                  'bodyPart'
                ]['id'];
                this.selectProcedureList[
                  index
                ].bodyPartName = this.cptcodeobject['bodyPart']['bodyPart'];
                this.homeBodyPartName = this.cptcodeobject['bodyPart'][
                  'bodyPart'
                ];
                this.getallproceduresbybodypartbyonchange(
                  this.selectProcedureList[index].bodyPartList[i].id,
                  index
                );
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallproceduresbybodypartbyonchange(bodypartId, index) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          this.selectProcedureList[index].procedureList = res['entity'];
          this.openpopuptemplateonchanged(
            this.selectProcedureList[index].procedureList,
            this.selectProcedureList[index].cptCode,
            index
          );
          if (
            this.cptcodeobject &&
            this.selectProcedureList[index].procedureList &&
            this.selectProcedureList[index].procedureList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].procedureList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].procedureList[i].id ==
                this.cptcodeobject['id']
              ) {
                this.selectProcedureList[
                  index
                ].procedureName = this.cptcodeobject['procedureName'];
                this.selectProcedureList[index].duration = this.cptcodeobject[
                  'duration'
                ];
                this.selectProcedureList[index].open = false;
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  openpopuptemplateonchanged(procedures, cptcode, ind) {
    return this.homeSelectionShared.openpopuptemplateonchanged(
      this,
      procedures,
      cptcode,
      ind
    );
  }

  cptcodeChange(value, index) {
    return this.homeSelectionShared.cptcodeChange(this, value, index);
  }

  getRoundedDate = (minutes, d = new Date()) => {
    return this.homeSelectionShared.getRoundedDate(minutes, d);
  };

  pushScheduledData(type) {
    const scheduleOn = this.datePipe.transform(this.homeDate, 'yyyy-MM-dd');
    this.findpaymode();
    if (
      this.homeDate &&
      this.homeLocation &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        }
      }
      const now = new Date();
      const zoneDate = new Date(
        now.getTime() + now.getTimezoneOffset() * 60000
      );
      zoneDate.setMinutes(zoneDate.getMinutes() + (+this.timeZone) + 15);
      const roundedDate = this.getRoundedDate(15, zoneDate);
      roundedDate.setSeconds(0);
      this.scheduledData = {
        scheduleId: this.scheduleappointmentid,
        scheduleOn: scheduleOn,
        scheduleOnStr: scheduleOn,
        dayOfweek: this.dayOfweek,
        location: this.homeLocation,
        insuranceId:
          this.homeInsurance &&
          this.homeInsurance != '' &&
          this.homeInsurance != 'self'
            ? this.homeInsurance
            : 0,
        inType:
          this.homeInsuranceType && this.homeInsuranceType != ''
            ? this.homeInsuranceType
            : 0,
        selectProcedureList: this.selectProcedureList,
        cptCodeList: this.cptCodeList,
        payMode: this.paymode,
        countryCode: this.countryCode,
        latitude: this.lat,
        longitude: this.lng,
        selectedExam: '',
        selectedExamId: '',
        today: this.datePipe.transform(roundedDate, 'yyyy-MM-dd'),
        timeZone: '',
        offsetmin: +this.timeZone,
        currentTime: this.datePipe.transform(roundedDate, 'hh:mm aa'),
        homeInsuranceName: this.homeInsuranceName ? this.homeInsuranceName : '',
      };

      sessionStorage.setItem(
        'scheduleData',
        JSON.stringify(this.scheduledData)
      );
      if (type === '' || type === 'no') {
        if (this.scheduleappointmentid && this.scheduleappointmentid != '') {
          this.router.navigate(['/profile-form', this.scheduleappointmentid]);
        } else {
          this.router.navigate(['/profile-form']);
        }
      }

      if (type == 'mobile') {
        if (this.scheduleappointmentid && this.scheduleappointmentid != '') {
          this.router.navigate(['/schedule-form', this.scheduleappointmentid]);
        } else {
          this.router.navigate(['/schedule-form']);
        }
      }
    }
  }

  checkRemainder(i) {
    if (i == 0 || i == 2 || i == 4) {
      return false;
    } else if (i == 1 || i == 3) {
      return true;
    }
    return false;
  }

  checkInCC() {
    if (this.countryCode == 'IN') {
      return true;
    }
    return false;
  }
  checkUSIndex24(i) {
    if (this.countryCode != 'IN') {
      if (i == 0 || i == 2 || i == 4) {
        return true;
      }
    }
    return false;
  }

  checkUSIndex13(i) {
    if (this.countryCode != 'IN') {
      if (i == 1 || i == 3) {
        return true;
      }
    }
    return false;
  }

  checkSelectProLength() {
    if (this.selectProcedureList && this.selectProcedureList.length > 1) {
      if (
        this.selectProcedureList.length == 2 ||
        this.selectProcedureList.length == 4
      ) {
        return true;
      } else if (
        this.selectProcedureList.length == 3 ||
        this.selectProcedureList.length == 5
      ) {
        return false;
      }
    }
    return false;
  }

  getSelectProcedureSize() {
    if (this.selectProcedureList && this.selectProcedureList.length == 1) {
      return 150;
    } else if (
      this.selectProcedureList &&
      this.selectProcedureList.length == 2
    ) {
      return 230;
    } else {
      return 300;
    }
  }
}
